export default "__VITE_ASSET__B5S6cvSk__"